/** Адреса фичи «Подключение» источника «Собственная»: литерал `/api/` — только здесь. */
export const OWN_URLS = {
  /** Виды цен общего каталога (`GET`, право `session.open` на ресурсе) — подсказка для вида цены по умолчанию. */
  priceTypes: () => '/api/platform/v1/catalog/price-types',
} as const
